<footer>
  <div class="container">
    <div class="row first-row">
      <div class="col-12 col-md-6">
        <div class="row">
          <div class="col-12 col-md-6">
            <a class="navbar-brand" [routerLink]="[ '/' ]" aria-label="Gea Waldviertler - zur Startseite">
              <img height="112" width="153" src="assets/logo-gea.png" alt=""/>
            </a>
          </div>
          <div class="col-md-6">
            <address>
              Niederschremser Straße 4b<br>
              3943 Schrems - Österreich<br>
            </address>
            <ul class="add">
              <li>Telefon: <a href="tel:+43285376503">+43 2853 76503</a></li>
              <li>Fax: <a href="fax:+43285376503888">+43 2853 76503 888</a></li>
              <li>Email: <a href="mailto:gea@gea.at">gea&#64;gea.at</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="heading">Filialfinder</div>
            <p>GEA in Deiner Nähe einfach die Postleitzahl eingeben und die nächste Gea-Filiale finden<br class="hidden-xs hidden-sm"/><br class="hidden-xs hidden-sm"/></p>
            <a class="btn btn-white" [routerLink]="[ '/filialen' ]" title="Filialfinder" aria-label="Filialfinder">Filiale finden</a>
          </div>
          <div class="col-12 col-md-6">
            <div class="heading">Newsletter</div>
            <p>Du möchtest immer die neuesten Informationen aus dem GEA Universum? Dann melde dich für unseren Email-Newsletter an. Immer informiert bleiben ...</p>
            <button class="btn btn-white" (click)="openSubscriptionsModal()">Zum Newsletter anmelden</button>
          </div>
        </div>
      </div>
    </div>
    @let cr = cmsResponse();
    @if (cr) {
      <div class="row">
        @for (group of cr.sitemap; track group; let i = $index) {
          <div class="col-12 col-md-2 footer-links">
            <div class="heading">
              <div [class]="expandableStates['ftexpand'+i]" (click)="toggleExpander('ftexpand' + i)">
                @if (group.target_url) {
                  <a href="{{ group.target_url }}">{{ group.heading }}</a>
                } @else {
                  <span>{{ group.heading }}</span>
                }
                <svg [class.expanded]="expandableStates['ftexpand'+i] == 'expanded'"
                  viewBox="0 0 32 17" xmlns="http://www.w3.org/2000/svg">
                  <line x1=2 y1=2 x2=16.7 y2=16.7 stroke="white" stroke-width="2" />
                  <line x1=16 y1=16 x2=30 y2=2 stroke="white" stroke-width="2" />
                </svg>
              </div>
            </div>
            <div class="expander" id="ftexpand{{ i }}" [class]="expandableStates['ftexpand'+i]">
              <ul class="items">
                @for (items of group.linkGroups; track items) {
                  @for (item of items; track item) {
                    <li>
                      @if (item.url) {
                        <a href="{{ item.url }}">{{ getLinkLabel(item) }}</a>
                      }
                      @if (! item.url) {
                        <span>{{ item.text }}</span>
                      }
                    </li>
                  }
                }
              </ul>
              @if (group.heading === 'Shop') {
                <button type="button" class="btn btn-white refund-trigger" (click)="openRefundModal()">Vertrag widerrufen</button>
              }
            </div>
          </div>
        }
      </div>
    }
    <div class="d-flex justify-content-between bottom flex-column-reverse flex-md-row">
      <div class="copy">© GEA {{ date.getFullYear() }}</div>
      <div class="brands">
        <img src="assets/brands/logo-waldviertler.svg" style="filter: invert(1);" alt="logo waldviertler" width="118" height="18" />
        <img src="assets/brands/logo-brennstoff.svg" style="filter: invert(1);" alt="logo brennstoff" width="62" height="46" />
        <img src="assets/brands/logo-akademie.svg" style="filter: invert(1);" alt="logo akademie" width="110" height="34" />
      </div>
      <div class="cookies" (click)="showCookieConsentPopup.set(true)">Cookie Einstellungen</div>
    </div>
  </div>
</footer>